import Box2DFactory from 'box2d-wasm';
import { makeDebugDraw } from './debugDraw'
import { parse, randomMap } from './map';

interface WGround {
  x: number
  y: number
  w: number
  h: number
  body: Box2D.b2Body
}

Box2DFactory().then(async Box2D => {
  const { b2Vec2, b2World, b2BodyDef, b2Body, b2PolygonShape, b2FixtureDef, b2_dynamicBody } = Box2D
  
  const gravity = new b2Vec2(0, 10);
  const world = new b2World(gravity);
  
  let { name, map: parsedMap } = randomMap();
  console.log(parsedMap)
  document.getElementById('map-id')!.innerText = name
  
  const [spawnX, spawnY] = parsedMap.mouseSpawns[0] ?? [5 * 30, -2 * 30]
  const playerStartPos = new b2Vec2(spawnX / 30, spawnY / 30);
  const grounds: WGround[] = []
  const cheeses = parsedMap.cheeses.map(([x, y]) => [x / 30, y / 30])
  const holes = parsedMap.holes.map(([x, y]) => [x / 30, y / 30])
  
  for(const ground of parsedMap.grounds) {
    const x = ground.x / 30;
    const y = ground.y / 30;
    const w = ground.length / 60;
    const h = ground.height / 60;
    const groundDef = new b2BodyDef();
    groundDef.set_position(new b2Vec2(x, y));
    const groundBody = world.CreateBody(groundDef);
    const groundFixtureDef = new b2FixtureDef();
    const groundBox = new b2PolygonShape();
    groundBox.SetAsBox(w, h);
    groundFixtureDef.set_shape(groundBox);
    groundBody.CreateFixture(groundFixtureDef);
    grounds.push({ x, y, w, h, body: groundBody })
  }

  const playerDef = new b2BodyDef();
  playerDef.set_position(playerStartPos);
  playerDef.fixedRotation = true;
  const playerBody = world.CreateBody(playerDef);
  playerBody.SetType(b2_dynamicBody);
  const playerFixtureDef = new b2FixtureDef();
  playerFixtureDef.set_density(2);
  playerFixtureDef.set_friction(0.2);
  playerFixtureDef.set_restitution(0.2);
  const playerShape = new b2PolygonShape();
  // playerShape.set_m_radius(0.5);
  playerShape.SetAsBox(0.5, 0.5);
  playerFixtureDef.set_shape(playerShape);
  playerBody.CreateFixture(playerFixtureDef);
  playerBody.SetSleepingAllowed(false);

  const maxTimeStepMs = 1/30*1000;
  const velocityIterations = 1;
  const positionIterations = 1;

  const canvas = document.getElementById("game") as HTMLCanvasElement;
  canvas.width = canvas.clientWidth * window.devicePixelRatio
  canvas.height = canvas.clientHeight * window.devicePixelRatio
  const ctx = canvas.getContext('2d')!;

  const keys: Record<string, boolean> = {};
  canvas.addEventListener("keydown", function (e) {
    if (e.repeat) {
      return
    }
    keys[e.code] = true;
  });

  window.addEventListener("keyup", function (e) {
    keys[e.code] = false;
  });

  const pixelsPerMeter = canvas.width / 800 * 30;

  const debugDraw = makeDebugDraw(ctx, pixelsPerMeter, Box2D);
  world.SetDebugDraw(debugDraw);

  let timeMs = 0;
  let lastMovementTime = 0;
  let lastVelocity = 0;
  let jumpAvailable = true;
  let jumpAvailableTime = 0;
  let jumping = false;
  const step = (deltaMs: number) => {
    timeMs += deltaMs;

    if (keys["Digit1"]) {
      playerBody.SetTransform(playerStartPos, 0);
      playerBody.SetLinearVelocity(0);
    }

    const moveSpeed = jumping ? 0.5 : 1;
    const linVel = playerBody.GetLinearVelocity();
    if (jumpAvailable && keys["KeyW"] && timeMs - jumpAvailableTime >= 50) {
      linVel.set_y(-5);
      jumpAvailable = false;
      jumping = true;
    }
    if(keys["KeyD"]) {
      if (linVel.get_x() < 3) {
        linVel.op_add(new b2Vec2(moveSpeed, 0));
      }
      lastMovementTime = timeMs;
    } else if (keys["KeyA"]) {
      if (linVel.get_x() > -3) {
        linVel.op_sub(new b2Vec2(moveSpeed, 0));
      }
      lastMovementTime = timeMs;
    } else if (timeMs - lastMovementTime < 200) {
      if (linVel.get_x() < 2.5 || linVel.get_x() > -2.5) {
        linVel.set_x(linVel.get_x() / 1.2);
      }
    }

    if (!jumpAvailable) {
      if (lastVelocity > 0) {
        if (lastVelocity > linVel.get_y()) {
          lastVelocity = -1;
          jumpAvailableTime = timeMs;
          jumping = false;
          jumpAvailable = true;
        } else {
          lastVelocity = linVel.get_y();
        }
      } else {
        lastVelocity = linVel.get_y();
      }
    }

    const clampedDeltaMs = Math.min(deltaMs, maxTimeStepMs);
    world.Step(clampedDeltaMs/1000, velocityIterations, positionIterations);
  };

  const fetchImage = async (url: string) => {
    if (url.endsWith('.svg')) {
      const img = new Image()
      const promise = new Promise(r => img.onload = r)
      img.src = url
      await promise
      return img
    }
    const resp = await fetch(url)
    const blob = await resp.blob()
    const img = await createImageBitmap(blob)
    return img
  }

  const earthTex = await fetchImage('earth.png')
    .then(b => ctx.createPattern(b, 'repeat'))
  earthTex?.setTransform(new DOMMatrix().scale(0.035))
  const grassTopTex = await fetchImage('grass-top.png')
    .then(b => ctx.createPattern(b, 'repeat-x'))
  grassTopTex?.setTransform(new DOMMatrix().scale(.035))
  const holeTex = await fetchImage('T.png')
  const cheeseTex = await fetchImage('F.png')

  let bgTex: ImageBitmap | HTMLImageElement | undefined
  if (parsedMap.background != null) {
    bgTex = await fetchImage(`backgrounds/${parsedMap.background}.svg`)
  }

  const drawCanvas = () => {
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    if (bgTex != null) {
      ctx.drawImage(bgTex, 0, 0, canvas.width, canvas.height)
    }
  
    ctx.save();
    ctx.scale(pixelsPerMeter, pixelsPerMeter);
    ctx.lineWidth /= pixelsPerMeter;

    for (const [x, y] of holes) {
      ctx.save()
      ctx.translate(x-1, y-1)
      ctx.scale(0.03, 0.03)
      ctx.drawImage(holeTex, 0, 0)
      ctx.restore()
    }

    for (const [x, y] of cheeses) {
      ctx.save()
      ctx.translate(x-1, y-1)
      ctx.scale(0.03, 0.03)
      ctx.drawImage(cheeseTex, 0, 0)
      ctx.restore()
    }
    
    ctx.fillStyle = 'rgb(255,255,0)';
    world.DebugDraw();

    for(const { x, y, w, h } of grounds) {
      ctx.save()
      ctx.translate(x - w, y - h)
      ctx.fillStyle = earthTex!
      ctx.fillRect(0, 0, w * 2, h * 2)
      ctx.fillStyle = grassTopTex!
      ctx.fillRect(0, 0, w * 2, h * 2)
      ctx.restore()
    }

    const playerPos = playerBody.GetPosition()
    ctx.font = "bold 30pt Verdana"
    ctx.translate(playerPos.x, playerPos.y - 1.2)
    ctx.scale(0.01, 0.01)
    ctx.fillStyle = 'rgb(151,226,235)'
    ctx.shadowColor = 'black'
    ctx.shadowBlur = 1.5
    ctx.textAlign = 'center'
    ctx.fillText('Qwerqwer', 0, 0)
    ctx.translate(0, 36)
    ctx.fillText('«Little mouse»', 0, 0)
  
    ctx.restore();
  };

  let handle;
  (function loop(prevMs) {
    const nowMs = window.performance.now();
    handle = requestAnimationFrame(loop.bind(null, nowMs));
    const deltaMs = nowMs-prevMs;
    step(deltaMs);
    drawCanvas();
  }(window.performance.now()));
})
